import React from "react";
import "./../Homepage.css";
import "./weekly.css";

//import breakoutSVG from "./../photos/breakout-design/breakout-design-F_Cu.svg";
import final3d from "./../photos/breakout-design/final-3d.webp";
import finalFootprint from "./../photos/breakout-design/final-footprint.webp";
import finalSch from "./../photos/breakout-design/final-sch.webp";
import firstFootprint from "./../photos/breakout-design/first-footprint.webp";
import firstSch from "./../photos/breakout-design/first-sch.webp";
import portFootprint from "./../photos/breakout-design/port-footprint.webp";
import portSch from "./../photos/breakout-design/port-sch.webp";

const Week5 = (props) => {
    return (
      <div className="HP-module">
        <div className="HP-subtitle">Week 5</div>
        <div className="HP-body">
            For this week, I built on my week 3 assignment (embedded programing) and worked on my circuit design. 
            My goal for the week was to design a breakout board for an embedded controller, of which I chose the board 
            I was programming on, the XIAO ESP32-C3. While this board is already slightly broken out, it still had opporotunities 
            to build a development board around it while minimizing difficulty due to the already present USB-C interface, which 
            was nice due to my little experience in electrical design tools. While I had designed circuits before, I had never 
            designed one on my computer, and especially not a printed circuit using EDA tools so my goal for the week was 
            to learn these tools. I decided to use KiCAD for my design and analysis, and I started by finding schematics and 
            footprints for my ESP32, which I found on DigiKey. I imported these specs and began designing my board. I first added 
            a LED to the power output of the board so that you can tell when the board is on, putting it in series with a current limiting resistor. 
            This simple task let me get a feel for the software, and the simple design is below.
        </div>
        <div className="HP-photoContainer">
            <div className="HP-photoObject">
                <img src={firstSch} className="HP-medPhoto"/>
                <div className="HP-caption">Schematic of ESP32 and LED</div>
            </div>
            <div className="HP-photoObject">
                <img src={firstFootprint} className="HP-medPhoto"/>
                <div className="HP-caption">Footprint of ESP32 and LED</div>
            </div>
        </div>
        <div className="HP-body">
            Next, to continue adding functionality of my development board, I added some ports to access the digital GPIO pins as well as the I2C interface. 
            In the first port, labeled J1, I added ports for all 11 GPIO pins on the XIAO board as well as 3.3v and GND for easy connection. I looked around 
            at several different socket types for footprints, and eventually found a simple one that looked like it would work well, a 13 port 2.0mm socket 
            connector. I used the same connector, but a 5 pin version, to connect 3.3v, 5v, GND, SDA, and SCL for I2c (found the pins for SDA and SCL on the schematic). 
            At this point I had a lot of traces across my footprint needed to connect all the sockets, so I got creative with routing traces underneath the ESP32 and 
            the sockets, and using the smart capabilities of the route tool to auto route traces was very useful. Here are some more photos of my updated board 
            with the ports.
        </div>
        <div className="HP-photoContainer">
            <div className="HP-photoObject">
                <img src={portSch} className="HP-medPhoto"/>
                <div className="HP-caption">Schematic of ESP32 with ports</div>
            </div>
            <div className="HP-photoObject">
                <img src={portFootprint} className="HP-medPhoto"/>
                <div className="HP-caption">Footprint of ESP32 with ports</div>
            </div>
        </div>
        <div className="HP-body">
            I then decided I wanted to add to my board some switches and buttons so I could modify the behaviour of my processor manually during runtime, a programmable user input. 
            I used the last two GPIO pins on the board, D9 and D10, for these special purposes. On both pins I put switches that in one configuration routed the pin to the 
            port as previously described for GPIO usage. When the D9 switch is flipped, the port then routes to a button, which is pulled low to ground by a resistor when not pressed, 
            and pulled to 3.3v when pressed. The D10 pin when switched away from GPIO usage connects to ground. I imagine this might be useful if you connected the port to some input logic 
            and wanted to turn off the part of the system or if you were drawing current from the pin and wanted a way to disconnect the subsystem. The button could be useful for any 
            real-time user input. With these additions, routing the traces became increasingly difficult without extra components or using extra space. After some time I found a layout 
            and route map that allowed every connection to be made successfully, and rendered the output in 3d. {/*The traces schematic can be found <a download href={"/src/photos/breakout-design/breakout-design-F_Cu.svg"}>here</a>.*/}
        </div>
        <div className="HP-photoContainer">
            <div className="HP-photoObject">
                <img src={finalSch} className="HP-medPhoto"/>
                <div className="HP-caption">Schematic with extra functionality</div>
            </div>
            <div className="HP-photoObject">
                <img src={finalFootprint} className="HP-medPhoto"/>
                <div className="HP-caption">Footprint with extra functionality</div>
            </div>
            <div className="HP-photoObject">
                <img src={final3d} className="HP-medPhoto"/>
                <div className="HP-caption">3d model of the development board</div>
            </div>
        </div>
        <div className="HP-body">
            At this point I had made a reasonably useful development board for helping interface with the controller. My next steps would be to add in some more real-time customizable 
            features (think jumper pins, etc.) or to try making a breakout board for a less friendly processor, but I ran out of time to build my board after taking a long time to learn the 
            software. I hope in a few weeks that I can use these skills to design and print a functional PCB. Given extra time I also think it would be a good idea to add bypass capacitors 
            around the power and GND lines (probably already in the XIAO chip but good practice), and a debounce capacitor for the button, and I will make these changes before printing my board 
            eventually.
        </div>
      </div>
    )
}

export default Week5;